<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE THIRTEENTH</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"><a id="page_iii"></a></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title"><span class="smallcaps">THE</span> THIRTEENTH</h1>
<p class="author">L. A. BANKS</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor"><img alt="Image" src="images/publisher.jpg"/>   <span class="smallcaps">ST. MARTIN</span>’<span class="smallcaps">S GRIFFIN</span>   <img alt="Image" src="images/publisher01.jpg"/>   <span class="smallcaps">NEW YORK</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ab6eee6a